interface DeleteProps {
  className?: string;
  height?: number;
  width?: number;
  onClick?: () => void;
}

export const Delete = (props: DeleteProps) => {
  return (
    <div className="cursor-pointer" onClick={props.onClick ?? undefined}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 18}
        height={props.height || 18}
        viewBox="0 0 18 18"
        fill="none"
        className={props.className}
      >
        <path
          d="M12.3333 4.0013V3.33464C12.3333 2.40121 12.3333 1.9345 12.1517 1.57798C11.9919 1.26438 11.7369 1.00941 11.4233 0.849625C11.0668 0.667969 10.6001 0.667969 9.66667 0.667969H8.33333C7.39991 0.667969 6.9332 0.667969 6.57668 0.849625C6.26308 1.00941 6.00811 1.26438 5.84832 1.57798C5.66667 1.9345 5.66667 2.40121 5.66667 3.33464V4.0013M7.33333 8.58464V12.7513M10.6667 8.58464V12.7513M1.5 4.0013H16.5M14.8333 4.0013V13.3346C14.8333 14.7348 14.8333 15.4348 14.5608 15.9696C14.3212 16.44 13.9387 16.8225 13.4683 17.0622C12.9335 17.3346 12.2335 17.3346 10.8333 17.3346H7.16667C5.76654 17.3346 5.06647 17.3346 4.53169 17.0622C4.06129 16.8225 3.67883 16.44 3.43915 15.9696C3.16667 15.4348 3.16667 14.7348 3.16667 13.3346V4.0013"
          stroke="#CD0202"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
